// 工具函数库

// get工具函数 获取数据
import axios from './axios'

export function get (url, data) {
  return request(url, 'GET', data)
}

export function post (url, data) {
  return request(url, 'POST', data)
}

function request (url, method, data) {
  return new Promise((resolve, reject) => {
    axios({
      method,
      url: url,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      params:data
    }).then(res => {
      if (res !== 0) {
        resolve(res)
      } else {
        reject(res)
      }
    })
  })
}
axios.interceptors.request.use(config => {
  // console.log(config);
  if (!config.url.includes('http')) {
    if (config.url[0] !== '/') {
      config.url = window.localStorage.getItem('pdaBASEURL') + '/' + config.url;
    } else {
      config.url = window.localStorage.getItem('pdaBASEURL') + config.url;
    }
  }
  return config
})